import PropTypes from "prop-types"
import { Box, Typography } from "@mui/material"
import { AutoMode } from "@mui/icons-material"

export default function AnimatedLoadingButton({ text = "Processing..." }) {
  return (
    <Box className="animated-loading-button">
      <Box className="animated-loading-icon">
        <AutoMode />
      </Box>
      <Typography variant="button">
        {text}
      </Typography>
    </Box>
  )
}

AnimatedLoadingButton.propTypes = {
  text: PropTypes.string,
}
